var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 23,
    height: 23,
    transform: "translate(151 16)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23",
    "data-name": "Mask Group 23",
    transform: "translate(-151 -16)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(151 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M12.81,1.143A11.6,11.6,0,0,0,1.143,12.81,11.6,11.6,0,0,0,12.81,24.476,11.6,11.6,0,0,0,24.476,12.81,11.6,11.6,0,0,0,12.81,1.143Zm0,21.667a10,10,0,1,1,10-10A10.029,10.029,0,0,1,12.81,22.81Z",
    transform: "translate(-1.143 -1.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M15.476,16.81l-4.5-4.5-4.5,4.5L5.143,15.476l4.5-4.5-4.5-4.5L6.476,5.143l4.5,4.5,4.5-4.5L16.81,6.476l-4.5,4.5,4.5,4.5Z",
    transform: "translate(0.69 0.69)",
    fill: "#114A65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/close-black.ac484d93a74f98303fa422c463da94ca.svg";
export { ForwardRef as ReactComponent };